import { render, staticRenderFns } from "./PrinterType.vue?vue&type=template&id=1cf95496&"
import script from "./PrinterType.vue?vue&type=script&lang=js&"
export * from "./PrinterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports